import { render, staticRenderFns } from "./global_totals.vue?vue&type=template&id=4a02575e&scoped=true"
import script from "./global_totals.vue?vue&type=script&lang=js"
export * from "./global_totals.vue?vue&type=script&lang=js"
import style0 from "./global_totals.vue?vue&type=style&index=0&id=4a02575e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a02575e",
  null
  
)

export default component.exports